import { DateTime } from 'luxon';
import SuperJSON from 'superjson';
import { TIME_ZONE } from '@common/utils/serialisation/TIME_ZONE';

SuperJSON.registerCustom<DateTime<true | false>, string | null>(
  {
    isApplicable: (v): v is DateTime => DateTime.isDateTime(v),
    serialize: v => v.toISO(),
    deserialize: v => {
      if (v) {
        return DateTime.fromISO(v, {
          zone: TIME_ZONE,
          setZone: true,
        });
      } else {
        return DateTime.invalid('DateTime missing');
      }
    },
  },
  'Luxon DateTime',
);
